import { createSlice } from "@reduxjs/toolkit";
import { COOKIE_THEME_MODE, THEME_DARK } from "envConfig";
import { cycleThemePreference, normalizeThemePreference } from "theme/themeMode";
import { CookieUtils } from "utils/CookieUtils";

interface GlobalState {
    mode: string | null | undefined;
}

const initialState : GlobalState = {
    mode: normalizeThemePreference(CookieUtils.getCookie(COOKIE_THEME_MODE) || THEME_DARK)
};

const globalSlice = createSlice({
    name: "global",
    initialState,
    reducers: {
        setMode: (state) => {
            state.mode = cycleThemePreference(state.mode);
            CookieUtils.setCookie(COOKIE_THEME_MODE, state.mode, 365);
        },
        restoreThemeFromCookie: (state) => {
            const mode = CookieUtils.getCookie(COOKIE_THEME_MODE);
            if (mode != null) {
                state.mode = normalizeThemePreference(mode);
            }
        }
    }
});

export default globalSlice.reducer;
export const { setMode, restoreThemeFromCookie } = globalSlice.actions;

